<div class="container mx-auto py-8" *transloco="let t">
  <!-- Tabs -->
  <ul class="flex border-b">
    <li class="-mb-px mr-1">
      <button (click)="setActiveTab('inicial')" [class.text-blue-500]="activeTab === 'inicial'"
        [class.border-blue-500]="activeTab === 'inicial'"
        class="bg-white inline-block py-2 px-4 border-b-2 font-semibold">
        {{ t('checklist.tabInitial') }}
      </button>
    </li>
    <li class="mr-1">
      <button (click)="setActiveTab('criar-editar')" [class.text-blue-500]="activeTab === 'criar-editar'"
        [class.border-blue-500]="activeTab === 'criar-editar'"
        class="bg-white inline-block py-2 px-4 border-b-2 font-semibold">
        {{ t('checklist.tabCreateEdit') }}
      </button>
    </li>
    <li class="mr-1">
      <button (click)="setActiveTab('bipar')" [class.text-blue-500]="activeTab === 'bipar'"
        [class.border-blue-500]="activeTab === 'bipar'"
        class="bg-white inline-block py-2 px-4 border-b-2 font-semibold">
        {{ t('checklist.tabScan') }}
      </button>
    </li>
  </ul>

  <!-- Content -->
  <div *ngIf="activeTab === 'inicial'" class="tab-content p-4">
    <div class="flex flex-col min-h-screen p-6 bg-white">
      <!-- Título da Página -->
      <div class="text-left mb-4">
        <h4 class="text-2xl font-bold">{{ t('checklist.title') }}</h4>
      </div>

      <!-- Caixa de Input de Data de Início e Data Final -->
      <div class="flex flex-wrap items-end mb-4 space-y-4 md:space-y-0">
        <div class="w-full md:w-60 mr-4">
          <label for="startDate" class="block text-sm font-medium text-gray-700">{{ t('checklist.startDate') }}</label>
          <input [(ngModel)]="startDate" type="datetime-local" id="startDate"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
        </div>
        <div class="w-full md:w-60 mr-4">
          <label for="endDate" class="block text-sm font-medium text-gray-700">{{ t('checklist.endDate') }}</label>
          <input [(ngModel)]="endDate" type="datetime-local" id="endDate"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm">
        </div>
        <div class="flex items-end space-x-2 ml-auto">
          <button [disabled]="!startDate" (click)="getOrdersForProduction()"
            class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
            {{ t('checklist.search') }}
          </button>
          <button [disabled]="!hasItemChecked" (click)="createProductionOrder()"
            class="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2">
            {{ t('checklist.createOrder') }}
          </button>
        </div>
      </div>

      <div class="flex-grow overflow-auto border p-4 bg-gray-50">
        <h2 class="text-lg font-medium mb-4 text-center">{{ orders.length > 0 ? orders.length : '' }} {{ t('checklist.pendingOrdersSuffix') }}
        </h2>
        <table *ngIf="!loading"
          class="min-w-full w-full bg-white border border-gray-300 rounded-md shadow-md table-auto">
          <thead class="bg-gray-100 text-sm"> <!-- Diminuindo o tamanho do texto no cabeçalho -->
            <tr>
              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300">
                <input type="checkbox" [title]="t('orders.selectAll')" [(ngModel)]="selectAll" (change)="toggleSelectAll()"
                  class="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-500">
              </th>
              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300 text-left">
                {{ t('checklist.colSaleNumber') }}</th>

              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300 text-left">
                {{ t('checklist.colDescription') }}</th>
              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300 text-left">
                {{ t('checklist.colQtItems') }}</th>
              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300 text-left">
                {{ t('checklist.colSku') }}</th>
              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300 text-left">
                {{ t('checklist.colStatus') }}</th>
              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300 text-left">
                {{ t('checklist.colCreatedDate') }}</th>
              <th class="bg-gray-100 p-2 text-gray-600 font-bold md:border md:border-gray-300 text-left">
                {{ t('checklist.colEndDate') }}</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200 text-xs"> <!-- Diminuindo o tamanho do texto no corpo -->
            <tr *ngFor="let order of orders" (click)="toggleSelection(order)"
              [class]="order.status == OrderStatusEnum.Cancelado ? 'text-red-500' : ''"
              class="hover:bg-gray-100 cursor-pointer">
              <td class="px-4 py-2 text-center">
                <input [disabled]="order.status == OrderStatusEnum.Cancelado" type="checkbox"
                  [(ngModel)]="order.checked"
                  class="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-500">
              </td>
              <td class="px-4 py-2 break-words">{{ order.orderId }}</td>
              <td class="px-4 py-2 break-words">{{ order.items[0].description }}</td>
              <td class="px-4 py-2 break-words">{{ order.items.length }}</td>
              <td class="px-4 py-2 break-words">{{ order.items[0].sku }}</td>
              <td class="px-4 py-2 break-words">{{ order.statusDescription }}</td>
              <td class="px-4 py-2 break-words">{{ order.createdDate | date:'dd/MM/yyyy HH:mm' }}</td>
              <td class="px-4 py-2 break-words">{{ order.manufacturingEndingDate | date:'dd/MM/yyyy HH:mm' }}</td>
            </tr>
          </tbody>
        </table>
      </div>


    </div>
  </div>

  <div *ngIf="activeTab === 'criar-editar'" class="tab-content p-4">
    <h2 class="text-xl font-bold">{{ t('checklist.createOrEdit') }}</h2>
    <p>{{ t('checklist.createEditContent') }}</p>
  </div>

  <div *ngIf="activeTab === 'bipar'" class="tab-content p-4">
    <app-prroduct-order-bip></app-prroduct-order-bip>
  </div>
</div>